import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { priceFormat } from 'apps/products/utils/priceFormat';

export default class UnitPrice extends PureComponent {
  static propTypes = {
    unitPrice: PropTypes.shape({
      price: PropTypes.number,
      per: PropTypes.string,
    }).isRequired,
    zeroAfterPound: PropTypes.bool,
  };

  render() {
    const {
      unitPrice: { price, per },
      zeroAfterPound = true,
    } = this.props;

    return price > 0
      ? <span className="fop-unit-price">
          {`${priceFormat({ value: price, zeroAfterPound, showPenceFraction: true })} ${per}`}
        </span>
      : null;
  }
}
